import { render } from "./RecordingsList.vue?vue&type=template&id=80a1edbc"
import script from "./RecordingsList.vue?vue&type=script&lang=js"
export * from "./RecordingsList.vue?vue&type=script&lang=js"

import "./RecordingsList.vue?vue&type=style&index=0&id=80a1edbc&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__